import '../../styles/author.css'

export default function Author() {
  return (
    <div className="author">
      <a target="_blank" rel="noreferrer" href="https://itfeelsharsh.pages.dev">{`made by Ha<rsh`}</a>
    </div>
  )
}